import { FC, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { hasMarketingConsent } from '../../consent/consentLoaders';

/**
 * Salje Meta Pixel "PageView" event na SVAKU navigaciju u SPA-u
 * (osim inicijalne — taj PageView salje loadMetaPixel() pri prvom ucitavanju
 * pixel-a, posle marketing consent-a).
 *
 * GDPR gate: ako korisnik nije prihvatio "marketing" kategoriju kolacica,
 * fbq nije ni ucitan i nista se ne salje. hasMarketingConsent() je dodatna
 * sigurnosna provera (defense-in-depth) — ako se nesto ucita pre nego sto
 * je korisnik prihvatio (npr. cache), ne pozivamo fbq.
 */
const MetaPixelPageViewComponent: FC = () => {
    const { pathname, search } = useLocation();
    const isInitialRoute = useRef(true);

    useEffect(() => {
        if (isInitialRoute.current) {
            isInitialRoute.current = false;
            return;
        }
        if (!hasMarketingConsent()) return;
        window.fbq?.('track', 'PageView');
    }, [pathname, search]);

    return null;
};

export default MetaPixelPageViewComponent;
